import enFrontend from '@assets/locales/en/frontend.json'
import i18next from 'i18next'
import './dateTimeFormatters'
import 'dayjs/locale/en'
import 'dayjs/locale/fr'
import 'dayjs/locale/es'
import 'dayjs/locale/de'
import 'dayjs/locale/ja'
import deAntd from 'antd/lib/locale/de_DE'
import enAntd from 'antd/lib/locale/en_US'
import esAntd from 'antd/lib/locale/es_ES'
import frAntd from 'antd/lib/locale/fr_FR'
import jaAntd from 'antd/lib/locale/ja_JP'
import dayjs from 'dayjs'
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import { BackendFetch, DevTools, FormatSimple, I18nextPlugin, Tolgee, withTolgee } from './custom-tolgee-i18next-plugin'
//todo: we can probably lazy load locale files for dayjs/i18next/antd

const supportedLocales = ['en', 'fr', 'es', 'ja', 'de'] as const

const toAntdLocale = (locale: (typeof supportedLocales)[number]) => {
  switch (locale) {
    case 'en':
      return enAntd
    case 'fr':
      return frAntd
    case 'es':
      return esAntd
    case 'de':
      return deAntd
    case 'ja':
      return jaAntd
    default:
      return enAntd
  }
}

const tolgee = Tolgee()
  .use(DevTools())
  .use(I18nextPlugin())
  .use(FormatSimple())
  .use(
    BackendFetch({ prefix: 'https://storage.googleapis.com/tolgee-cdn-bestbuy-dev/76aa19d49dd671703a22451fd5969e2f' })
  )
  .init({
    apiUrl: 'https://tolgee.gravitate.energy',
    apiKey: 'tgpak_gm3v64tbnjvwsndrnfyhkm3gobwhey3fmzrg623bgvwg23a',
    ns: ['frontend'],
    defaultNs: 'frontend',
    fallbackLanguage: 'en',
    language: 'en',
    projectId: 37,
  })

const initPromise = withTolgee(i18next, tolgee)
  .use(I18nextBrowserLanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: supportedLocales,
    fallbackLng: ['en'],
    interpolation: {
      escapeValue: false,
    },
    ns: ['frontend'],
    defaultNS: 'frontend',
    debug: true,
    returnEmptyString: false,
  })
  .finally(() => i18next.addResourceBundle('en', 'frontend', enFrontend, true, true))

const isSupportedLocale = (v: unknown): v is (typeof supportedLocales)[number] =>
  supportedLocales.findIndex((x) => x === v) !== -1
const LOCALE_KEY = 'i18n-locale'
export const getLocaleSetting = () => {
  const unparsed = localStorage.getItem(LOCALE_KEY) ?? i18next.language
  if (isSupportedLocale(unparsed)) {
    return unparsed
  }
}

export const getAntdLocale = () => {
  const locale = getLocaleSetting() || 'en'
  return toAntdLocale(locale)
}

export const setLocaleSetting = (locale: (typeof supportedLocales)[number], noReload?: boolean) => {
  localStorage.setItem(LOCALE_KEY, locale)
  if (!noReload) location.reload()
}

const setting = getLocaleSetting()
const value = initPromise
  .then(() => {
    if (setting) return i18next.changeLanguage(setting)
  })
  .then(() => dayjs.locale(i18next.language))

export default value
